"use client";

import CulturesList from "@/views/culture/components/cultures-list";
import CultureMoreInfo from "@/views/culture/components/culture-more-info";
import CultureHeader from "@/views/culture/components/culture-header";

const CultureView = () => {
  return (
    <div>
      <CultureHeader />
      <CulturesList />
      <CultureMoreInfo />
    </div>
  );
};

export default CultureView;
